import { css } from "@emotion/react";

export const containerStyle = css`
  margin-bottom: 16px;
`;

export const captionStyle = css`
  display: block;
  margin-bottom: 8px;
`;

export const rowStyle = css`
  margin-top: 12px;

  .ant-form-item {
    margin-bottom: 0;
  }
`;

export const floorSelectStyle = css`
  width: 160px;
`;

export const textInputStyle = css`
  width: 240px;
`;

export const areaStackStyle = css`
  width: 100%;
`;
